// extracted by mini-css-extract-plugin
module.exports = {"search":"delivery-data_search_d7Ft4","itemWrap":"delivery-data_itemWrap_14m92","item":"delivery-data_item_dt5ID"};